/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, 	@typescript-eslint/no-unsafe-member-access */
import React from 'react';
import './spinner.scss';

const Spinner = ({ addClassName: addClassName }: { addClassName?: string }) => (
  <img src={require('images/spinner.svg').default} alt="spinner" className={'spinner ' + addClassName} />
);

export default Spinner;
